(function(){
  document.addEventListener('DOMContentLoaded', function() {
    console.log(12321321);
    const discountCodeForm = document.querySelector('#cart-discount-form');
    const discountCodeInput = document.querySelector('#discount-code-input');
    const discountCodeSuccess = document.querySelector('#discount-code-success');
    const discountCodeError = document.querySelector('#discount-code-error');
    const discountRemove = document.querySelectorAll('.remove_discount'); 
    const cartDrawer = document.querySelector('cart-drawer'); 

    async function removeSpecificDiscount(codeToRemove) {
      try {
        // Получаем текущие промокоды в корзине
        const cartResponse = await fetchOrShowError('Cart fetch', 'cart.js');
        const currentDiscounts = await cartResponse.json();

        // Формируем массив всех промокодов, кроме удаляемого
        const remainingDiscounts = currentDiscounts.discount_codes.filter(code => code !== codeToRemove);
        
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            discount: remainingDiscounts.join(',') // Передаем оставшиеся промокоды
          })
        });

        const cartNew = await fetchOrShowError('Cart fetch', 'cart.js');
        const cartNewJson = await cartNew.json();

        if (response.ok) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            cartData: cartNewJson,
          });
        } else {
          console.error('Ошибка при удалении промокода:', response.status);
        }
      } catch (error) {
        console.error('Произошла ошибка:', error);
      }
    }

    document.addEventListener('click', function(e) {
      if ( e.target.matches('.remove_discount') || e.target.closest('.remove_discount')) {
        let $this;
        if ( e.target.classList.contains('remove_discount') ) {
            $this = e.target;
        } else {
            $this = e.target.closest('.remove_discount');
        }
        let discountCode =  $this.dataset.code;
        removeSpecificDiscount(discountCode);
      }
    });

    // / Hide both success and error messages initially
    const hideMessages = () => {
      discountCodeSuccess.style.display = "none";
      discountCodeError.style.display = "none";
    };

    // Function to display error messages
    const showError = (msg) => {
      discountCodeError.textContent = msg;
      discountCodeError.style.removeProperty('display');
    };

    // Function to display success messages
    const showSuccess = (msg) => {
      discountCodeSuccess.textContent = msg;
      discountCodeSuccess.style.removeProperty('display');
    };

    // Request data from the server. Throw a labeled error if it fails.
    const fetchOrShowError = async (label, url) => {
      const localeAwareUrl = window.Shopify.routes.root + url;
      const response = await fetch(localeAwareUrl);
      if (!response.ok) {
        throw new Error(`${label} failed: ${response.status} ${response.statusText}`);
      }
      return response;
    };

    // New helper for applying discounts via update.js
    const applyDiscount = async (code) => {
      let upperCaseCode = code.toUpperCase();
      console.log(upperCaseCode);
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: upperCaseCode })
      });
      if (!response.ok) {
        throw new Error(`Discount application failed: ${response.status} ${response.statusText}`);
      }
      return response;
    };

    // Check the cart to see if a specific discount code has been applied.
    const checkForDiscount = (cart, code) => {
      // Check for order-level discounts
      let upperCaseCode = code.toUpperCase();
      console.log('upperCaseCode', upperCaseCode);
      if (cart.cart_level_discount_applications
          && cart.cart_level_discount_applications.some((app) => app.title.toUpperCase() === upperCaseCode)) {
        return true;
      }

      // Check for line item discounts
      if (cart.items.some((item) => item.discounts?.some((discount) => discount.title.toUpperCase() === upperCaseCode))) {
        return true;
      }

      return false;
    };

    // Intercept the form being submitted and apply the discount code.
    // if ( discountCodeForm ) {
    //   discountCodeForm.onsubmit = async (e) => {
    //     e.preventDefault();
    //     hideMessages();

    //     // Field must not be empty
    //     const code = discountCodeInput.value.trim().toUpperCase();
    //     if (!code) {
    //       showError('Enter a discount code');
    //       return;
    //     }

    //     try {
    //       await applyDiscount(code);

    //       // Check if the discount was actually applied instead just assuming it
    //       // succeeded.
    //       const cartResponse = await fetchOrShowError('Cart fetch', 'cart.js');
    //       const cartDrawer = document.querySelector('cart-drawer'); 
    //       const cart = await cartResponse.json();

    //       if (checkForDiscount(cart, code)) {
    //         publish(PUB_SUB_EVENTS.cartUpdate, {
    //           source: 'product-form',
    //           cartData: cart,
    //         });
    //       } else {
    //         showError('Enter a valid discount code');
    //       }
    //     } catch(e) {
    //       showError(e);
    //     }
    //   };
    // }
    
    // }, false);
    
    document.addEventListener("click", async function (e) {
      const btn = e.target.closest("#apply-discount-btn");
      if (!btn) return;

      e.preventDefault();

      const drawer = btn.closest("cart-drawer");
      if (!drawer) return;

      const input = drawer.querySelector("#discount-code-input");
      const success = drawer.querySelector("#discount-code-success");
      const error = drawer.querySelector("#discount-code-error");

      success.style.display = "none";
      error.style.display = "none";

      const code = input.value.trim().toUpperCase();
      if (!code) {
        error.textContent = "Enter a discount code";
        error.style.display = "block";
        return;
      }

      btn.disabled = true;

      try {
        await fetch(Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ discount: code }),
        });

        const waitForDiscount = async (maxTries = 5, interval = 100) => {
          for (let i = 0; i < maxTries; i++) {
            const cart = await fetch(Shopify.routes.root + "cart.js").then(
              (r) => r.json()
            );

            if (
              cart.cart_level_discount_applications?.some(
                (d) => d.title.toUpperCase() === code
              ) ||
              cart.items.some((item) =>
                item.discounts?.some((d) => d.title.toUpperCase() === code)
              )
            ) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "discount",
                cartData: cart,
              });
              success.textContent = "Discount applied";
              success.style.display = "block";
              return true;
            }

            await new Promise((r) => setTimeout(r, interval));
          }
          return false;
        };

        const applied = await waitForDiscount();

        if (!applied) {
          error.textContent = "Enter a valid discount code";
          error.style.display = "block";
        }
      } catch (err) {
        error.textContent = "Enter a valid discount code";
        error.style.display = "block";
      } finally {
        btn.disabled = false;
      }
    });
  });
})();
